export const LOG_TYPES = {
  CLEAR: 'Clear',
  INFO: 'Info',
  WARN: 'Warning',
  DEBUG: 'Debug',
  ERROR: "Error",
  CRITICAL: "Critical",
};



// WEBPACK FOOTER //
// ./src/constants/logger.js